import './index.css';
import Daas from './App';
import reportWebVitals from './reportWebVitals';
import { appName, getBuildTarget, setAppHubProps, TBuildTarget } from './service/utils/env';
import { IAppHubProps } from './service/types';
import { startSentryMonitor, stopSentryMonitor } from './service/utils/sentry';
import { createRoot } from 'react-dom/client';

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

const useSentry = (['PROD', 'STG1'] as TBuildTarget[]).indexOf(getBuildTarget()) > -1;

const render = (props?: IAppHubProps) => {
  if (getBuildTarget() === 'STG1') {
    console.log(props);
  }
  const { container = document.body, user } = (props ? props : {}) as IAppHubProps;
  const mountedNode = container.querySelector('#root');
  const root = createRoot(mountedNode);
  root.render(<Daas />);
};

if (!window.__POWERED_BY_QIANKUN__) {
  render();
}

export async function bootstrap() {
  console.log(`${appName} bootstraped`);
}

export async function mount(props: IAppHubProps) {
  if (getBuildTarget() === 'STG1') {
    console.log(`${appName} mount`);
    console.log(props);
    console.log(window.__POWERED_BY_QIANKUN__);
  }
  setAppHubProps(props);
  if (useSentry) {
    startSentryMonitor();
  }
  render(props);
}
// @ts-ignore
console.log(process.env);

export async function unmount() {
  const $app = document.getElementById('root');
  if ($app) {
    ReactDOM.unmountComponentAtNode($app);
  }
  if (useSentry) {
    stopSentryMonitor();
  }
}

export async function update(props: any) {
  console.log(`${appName} update props', prop`);
}
